<template>
  <div class="u-wrapper-panel">
    <div class="progress">
      {{ (progress * 100).toFixed(2) }} %
    </div>
    <infos-media
      v-for="keypoint in keypoints"
      :progress="progress"
      :baseProgress="keypoint.progress * .01"
      :title="keypoint.title"
    />
  </div>
</template>

<script>

import { webGL } from '@/webGL/WebGL'
import { Environment } from '@/webGL/objects/Environment'
import { CameraAnimation } from '@/webGL/CameraAnimation'
import { textureLib } from '@/webGL/TextureLib'

import { keypoints } from '@/assets/data'

import InfosMedia from '@/components/InfosMedia'
import { gui, guiObj } from '@/utils/gui'

export default {
  components: {
    InfosMedia
  },

  computed: {
    keypoints () {
      return keypoints
    }
  },

  data () {
    return {
      progress: 0
    }
  },

  created () {
    this.addEnvironment()
    this.gui()
  },

  methods: {
    async addEnvironment () {

      await textureLib.promise
      // webGL.scene.environment = textureLib.envMap
      webGL.scene.environment = textureLib.envMapHdr

      this.environment = new Environment(!this.$route.query.model ? 'full' : this.$route.query.model)
      webGL.scene.add(this.environment)

      if (!this.$route.query.debug) {
        await this.environment.promise
        this.cameraAnimation = new CameraAnimation(webGL.camera, this.environment.animationClip)

        setTimeout(() => {
          this.cameraAnimation.active = true
          console.log(this.$route.query)
        }, 2000)
      }
    },

    gui () {
      const guiEnvMap = gui.addFolder('EnvMap')
      guiEnvMap.add(guiObj, 'envMap').onChange(() => {
        if (guiObj.envMap) {
          webGL.scene.environment = textureLib.envMapHdr
        }
        else {
          webGL.scene.environment = null
        }
      })
    },

    onUpdate (time) {
      if (this.controls) {
        this.controls.update()
      }
      if (this.cameraAnimation) {
        this.cameraAnimation.pointerPosition = this.$device.pointer.smooth
        this.progress = this.cameraAnimation.progress
      }
    }
  },

  beforeUnmount () {
    if (this.controls) {
      this.controls.dispose()
      this.$refs.main.removeEventListener('pointerdown', this.controls.onPointerDown)
      this.$refs.main.removeEventListener('pointercancel', this.controls.onPointerCancel)
    }
  }
}
</script>

<style lang="stylus">
.progress
  position absolute
  top 0
  left 0
  background-color white
  color black
  font-size 16px
</style>